import { useActive, useCommands } from '@remirror/react';
import React, { FC, useCallback } from 'react';
import { CommandButton, ICommandButtonProps } from '../../../components';
import { WFormatUnderlineExtension } from '../WFormatUnderlineExtension';

export type IToggleWFormatUnderlineButtonProps = Omit<
  ICommandButtonProps,
  'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect'
>;

export const ToggleWFormatUnderlineButton: FC<IToggleWFormatUnderlineButtonProps> = (props) => {
  const type = 'underline';
  const { toggleWFormatUnderline: command, focus } = useCommands<WFormatUnderlineExtension>();
  const active = useActive<WFormatUnderlineExtension>().wFormatUnderline({
    type,
  });
  const enabled = command.enabled({ type });

  const handleClick = useCallback(() => {
    if (enabled) {
      command({ type });
      focus();
    }
  }, [command]);

  return (
    <CommandButton
      {...props}
      commandName="toggleWFormatUnderline"
      active={active}
      enabled={enabled}
      onSelect={handleClick}
    />
  );
};
